import cn from 'classnames'; // Bibliotecas
import './Bag.css'; // CSS

// IMG
import BagIcon from './../../img/bag-icon.svg';
import EggIcon from './../../img/egg-icon.svg';

function Bag({onClick, quantity, visibility, animation}){
    return (
        <div className={cn("bag", {"bag--animation": animation, "bag--hide": !visibility})} onClick={onClick}>
            <span className="bag__quantity">{quantity}</span>
            <img src={BagIcon} className="bag__icon" />

            <div className="bag__egg">
                <img src={EggIcon} />
            </div>
        </div>
    );
}

export default Bag;